export const NAME_ITEMS = [
    { description: 'FAC', color: 'purple' },
    { description: 'Captaçāo', color: 'pink' },
    { description: 'Visita cliente', color: 'cyan' },
    { description: 'Plantāo', color: 'orange' },
    { description: 'Ausente', color: 'green' },
    { description: 'Outros', color: 'brown' }
]